import classNames from 'classnames';
import React from 'react';
import { MenuItem, Nav, Navbar, NavDropdown, NavItem } from "react-bootstrap";
import connect from 'react-redux/lib/connect/connect';
import { LinkContainer } from "react-router-bootstrap";
import { Link } from 'react-router-dom';
import { compose } from "recompose";
import { bindActionCreators } from 'redux';
import { routes } from "../../../constants";
import logo from '../../../images/logo_rev.png';
import { sessionActions } from '../../../state/modules/session';
import { Icon } from '../../components';

const NavDropdownTitle = () => (
  <button className='btn navbar-btn'>
    <Icon icon='settings' />
  </button>
);

const MenuNav = ({
  logout,
  userFullName
}) => (
    <Nav pullRight>
      <NavDropdown id='admin-user-admin-nav' eventKey={1} title={'User Admin'} noCaret={true}>
        <LinkContainer to={routes.adminPortal.dashboard} exact={true}>
          <NavItem eventKey={1.1}>User</NavItem>
        </LinkContainer>
        <LinkContainer to={routes.adminPortal.cpdPoint}>
          <NavItem eventKey={1.2}>Kaplan Import</NavItem>
        </LinkContainer>
        <LinkContainer to={routes.adminPortal.adminTaskGroup}>
          <NavItem eventKey={1.3}>Admin Tasks</NavItem>
        </LinkContainer>
      </NavDropdown>
      <NavDropdown id='admin-configuration-nav' eventKey={2} title={'Configuration'} noCaret={true}>
        <LinkContainer to={routes.adminPortal.industry}>
          <NavItem eventKey={2.1}>Industry</NavItem>
        </LinkContainer>
        <LinkContainer to={routes.adminPortal.cpdCategory}>
          <NavItem eventKey={2.2}>CPD Category</NavItem>
        </LinkContainer>
        <LinkContainer to={routes.adminPortal.publisher}>
          <NavItem eventKey={2.3}>Publisher</NavItem>
        </LinkContainer>
        <LinkContainer to={routes.adminPortal.qualificationType}>
          <NavItem eventKey={2.4}>Qualification Type</NavItem>
        </LinkContainer>
      </NavDropdown>
      <NavDropdown id='admin-reporting-nav' eventKey={3} title={'Reporting'} noCaret={true}>
        <LinkContainer to={routes.adminPortal.content}>
          <NavItem eventKey={3.1}>Content</NavItem>
        </LinkContainer>
        <LinkContainer to={routes.adminPortal.contentRating}>
          <NavItem eventKey={3.2}>Content Rating</NavItem>
        </LinkContainer>
        <LinkContainer to={routes.adminPortal.cpdAvailability}>
          <NavItem eventKey={3.3}>CPD Availability</NavItem>
        </LinkContainer>
        <LinkContainer to={routes.adminPortal.userEngagement}>
          <NavItem eventKey={3.4}>User Engagement</NavItem>
        </LinkContainer>
        <LinkContainer to={routes.adminPortal.testing}>
          <NavItem eventKey={3.5}>Testing</NavItem>
        </LinkContainer>
        <LinkContainer to={routes.adminPortal.contentCompletion}>
          <NavItem eventKey={3.6}>Content Completion</NavItem>
        </LinkContainer>
        <LinkContainer to={routes.adminPortal.userCpdProgressReport}>
          <NavItem eventKey={3.7}>User CPD Progress Report</NavItem>
        </LinkContainer>
        <LinkContainer to={routes.adminPortal.endOfYearReport}>
          <NavItem eventKey={3.8}>End of Year Report</NavItem>
        </LinkContainer>
      </NavDropdown>
      <NavDropdown id='nav-menu' eventKey={4} title={<NavDropdownTitle />} noCaret={true}>
        <MenuItem header>Logged in as {userFullName}</MenuItem>
        <MenuItem divider />
        <LinkContainer exact={true} to={routes.app.dashboard}>
          <MenuItem eventKey={4.1}>
            Go to User Portal
          </MenuItem>
        </LinkContainer>
        <MenuItem
          href={`mailto:support@thinkcaddie.com?subject=Caddie Support Request&cc=helpdesk@complii.com.au`}
          eventKey={4.2}>
          Support
        </MenuItem>
        <MenuItem eventKey={4.3} onClick={(e) => logout()}>
          Log out
        </MenuItem>
      </NavDropdown>
    </Nav>
  );

const AdminNav = ({
  ...props
}) => (
    <Navbar
      className={classNames('navbar-signup')}
      role='navigation'
      fluid={true}>
      <Navbar.Header>
        <Navbar.Toggle />
        <Navbar.Brand>
          <Link to={routes.adminPortal.dashboard}>
            <img src={logo} alt='Caddie' />
          </Link>
        </Navbar.Brand>
      </Navbar.Header>
      <Navbar.Collapse>
        <MenuNav {...{ ...props }} />
      </Navbar.Collapse>
    </Navbar >
  )

const mapStateToProps = () => ({})

const mapDispatchToProps = (dispatch) => ({
  logout: bindActionCreators(sessionActions.session.logout, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(AdminNav)


// WEBPACK FOOTER //
// ./src/containers/partials/nav/admin-nav.js